"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const PreQuoteModal_vue_1 = __importDefault(require("@becrop/components/ClientFarmListView/components/PreQuoteModal.vue"));
const Farm_1 = __importDefault(require("@becrop/abstract/Models/Farm"));
const Farm_2 = __importDefault(require("@becrop/components/ClientFarmListView/modules/models/Farm"));
const GisField_1 = __importDefault(require("@becrop/components/ClientFarmListView/modules/models/GisField"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
let UpgradeTeaser = class UpgradeTeaser extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isPreQuoteModalActive = false;
    }
    dismissPreQuoteModal() {
        this.isPreQuoteModalActive = false;
    }
    deployPreQuoteModal() {
        this.isPreQuoteModalActive = true;
    }
    fieldsParser(fields) {
        return fields
            .map((field) => new GisField_1.default({
            id: field.id,
            gfId: -1,
            name: field.name,
            geodata: field.geodata,
            metadata: {
                extension: {
                    value: field.extension,
                    unit: field.unit
                }
            },
            crop: new Crop_1.default({
                id: -1,
                name: field.crop.name,
                color: field.crop.color,
                icon: field.crop.logo
            }),
        }));
    }
    farmParser(f) {
        return new Farm_2.default({
            id: f.id,
            name: f.name,
            created_at: '',
            client_name: f.client_name,
            client_code: f.client_code,
            total_fields: f.total_fields,
            total_extension: f.total_extension,
            preferred_unit: f.unit,
            gis_fields: f.fields.map((field) => new GisField_1.default({
                id: field.id,
                gfId: -1,
                name: field.name,
                geodata: field.geodata,
                metadata: {
                    extension: {
                        value: field.extension,
                        unit: field.unit
                    }
                },
                crop: new Crop_1.default({
                    id: -1,
                    name: field.crop.name,
                    color: field.crop.color,
                    icon: field.crop.logo
                }),
            })),
            geodata: '',
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], UpgradeTeaser.prototype, "hovered", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new Farm_1.default({
            id: -1,
            name: '-',
            client_code: '-',
            client_name: '-',
            is_generative_zone: false,
            total_extension: -1,
            total_fields: -1,
            fields: [],
            unit: '-',
            recommendations: [],
            generative_zones: [],
            fields_linked_to_projects: []
        }) })
], UpgradeTeaser.prototype, "currentFarm", void 0);
UpgradeTeaser = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon, Button: bmk_ui_framework_1.Button, PreQuoteModal: PreQuoteModal_vue_1.default
        },
    })
], UpgradeTeaser);
exports.default = UpgradeTeaser;
